var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSwimmingpool = function SvgSwimmingpool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m.08 10.6.79-1.77a1 1 0 0 1 1.28-.49l.89.39a7.26 7.26 0 0 0 6.18 0 11.08 11.08 0 0 1 9.32 0l.88.39a1 1 0 0 1 .5 1.28l-.79 1.77a1 1 0 0 1-1.28.49l-.85-.39a7.26 7.26 0 0 0-6.18 0 11.08 11.08 0 0 1-9.32 0l-.88-.39a1 1 0 0 1-.54-1.28m.5 8.17.88.39a11.12 11.12 0 0 0 9.32 0 7.26 7.26 0 0 1 6.18 0l.89.4a1 1 0 0 0 1.28-.49l.79-1.77a1 1 0 0 0-.5-1.28l-.88-.4a11.08 11.08 0 0 0-9.32 0 7.26 7.26 0 0 1-6.18 0l-.89-.39a1 1 0 0 0-1.28.49L.08 17.5a1 1 0 0 0 .5 1.27",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m.08 3.7.79-1.77a1 1 0 0 1 1.28-.49l.89.4a7.26 7.26 0 0 0 6.18 0 11.12 11.12 0 0 1 9.32 0l.88.39a1 1 0 0 1 .5 1.27l-.79 1.77a1 1 0 0 1-1.28.49L17 5.38a7.26 7.26 0 0 0-6.18 0 11.08 11.08 0 0 1-9.32 0l-.88-.4A1 1 0 0 1 .08 3.7"
  })));
};
export default SvgSwimmingpool;